import request from "@/utils/request";
export function navbar(data) {
    return request({
        url: '/api/portal/v1/portal/queryAllLinks',
        method: 'post',
        data
    })
}
export function partners(data) {
    return request({
        url: '/api/portal/v1/portal/queryAllLinks',
        method: 'post',
        data
    })
}
export function news(data) {
    return request({
        url: '/api/portal/v1/portal/selectColumnNewsInfo',
        method: 'post',
        data
    })
}
export function newsDetail(data) {
    return request({
        url: '/api/portal/v1/portal/selectById',
        method: 'post',
        data
    })
}




export function count(data) {
    return request({
        url: '/api/portal/v1/portal/selectPortalCount',
        method: 'post',
        data
    })
}
export function swiper(data) {
    return request({
        url: '/api/portal/v1/portal/queryAllSwiper',
        method: 'post',
        data
    })
}